import GoneFishin from './GoneFishin'

export default GoneFishin
